import { render } from "./ed-organism-enquiry-list-large.vue?vue&type=template&id=1588d2ea"
import script from "./ed-organism-enquiry-list-large.vue?vue&type=script&lang=js"
export * from "./ed-organism-enquiry-list-large.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__